import PropTypes from "prop-types";

const CommonButton = ({
  children,
  onClick,
  disabled = false,
  variant = "primary",
  className = "uniform-button",
}) => {
  return (
    <button
      onClick={onClick}
      className={`btn btn-${variant} fw-semibold px-3 py-2 me-2  rounded ${className}`}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

CommonButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  variant: PropTypes.string,
  className: PropTypes.string,
};

export default CommonButton;
